import { createContext, useContext } from "react";
import { AlarmWizardStore } from "./AlarmWizardStore";

const AlarmWizardStoreContext = createContext<AlarmWizardStore | null>(null);

export const useAlarmWizardStore = (): AlarmWizardStore => {
	const ctx = useContext(AlarmWizardStoreContext);
	if (!ctx) throw new Error("useAlarmWizardStore must be used within <AlarmWizardStoreProvider>");
	return ctx;
};

export const AlarmWizardStoreProvider = AlarmWizardStoreContext.Provider;
